import { useQuery } from '@tanstack/react-query';
import { laboratoryService } from '../laboratoryService';

/**
 * Fetches the entered results for a lab order. Cached and shared across every
 * result editor bound to the same order, so mounting/re-mounting editors no
 * longer re-hits the API.
 */
export function useLabResults(orderId?: string) {
  return useQuery({
    queryKey: ['lab-results', orderId],
    queryFn: () => laboratoryService.getResults(orderId as string),
    enabled: !!orderId,
    staleTime: 15000,
  });
}
